<template>
  <div
    ref="optionItem"
    class="group relative cursor-pointer text-center"
    :class="{
      'is-oos-option': isOos,
      active: isActive
    }"
    :title="option.name"
    @click="$emit('onClick', { option, isSeeMore })"
  >
    <div
      v-if="isInsideModal && option.title"
      class="!max-md:hidden absolute left-1/2 top-0 z-10 hidden -translate-x-1/2 whitespace-nowrap rounded bg-primary px-2 py-1 text-xs text-white opacity-0 transition-all after:absolute after:bottom-0 after:left-1/2 after:size-0 after:-translate-x-1/2 after:translate-y-full after:border-x-[5px] after:border-b-[0] after:border-t-[5px] after:border-solid after:border-x-transparent after:border-b-transparent after:border-t-primary after:content-[''] group-hover:-translate-y-1/2 group-hover:opacity-100 lg:flex"
    >
      {{ option.title }}
    </div>
    <div
      class="aspect-square overflow-hidden rounded-base border transition-colors hover:border-gray-300"
      :class="{
        'before:absolute before:left-0 before:top-1/2 before:z-out-of-stock before:block before:h-1 before:w-full before:origin-center before:rotate-45 before:bg-white after:absolute after:left-0 after:top-1/2 after:z-out-of-stock after:block after:h-1 after:w-full after:origin-center after:-rotate-45 after:bg-white':
          isOos && !isSeeMore,
        'border-transparent transition-opacity ease-in-out': isSeeMore,
        relative: isSeeMore || isOos,
        'border-primary hover:border-primary': isActive && !isOos,
        'border-pink hover:border-pink': isActive && isOos && !isSeeMore
      }"
    >
      <img
        class="aspect-square rounded-base bg-white transition-all duration-300 ease-in-out group-[&.is-oos-option:not(.is-see-more)]:opacity-40 group-[.custom-variants-modal]:hover:scale-105"
        :src="itemImageUrl"
        loading="lazy"
        :alt="optionName"
        :width="200"
        :height="200"
        :class="{
          'ease transition-all duration-300 hover:scale-110': isInsideModal,
          'opacity-100': isImgLoaded,
          'opacity-0': !isImgLoaded
        }"
        @load="isImgLoaded = true"
      />

      <span
        v-if="isSeeMore"
        class="absolute left-0 top-0 flex size-full items-center justify-center bg-black/50 text-xl font-bold text-white transition-all ease-in-out group-[&.active]:text-primary"
        >{{ '+' + restOptionsAmount }}</span
      >
    </div>
    <span
      v-if="!isSeeMore"
      class="block pt-xxs text-xs leading-tight text-gray-darkest transition-all ease-in-out"
      :class="{
        'text-primary': isActive && !isOos,
        'text-pink opacity-100': isActive && isOos
      }"
      >{{ optionName }}</span
    >
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

defineEmits(['onClick']);

const isImgLoaded = ref(false);

const props = defineProps({
  option: {
    type: Object,
    required: true
  },
  isSeeMore: {
    type: Boolean,
    default: false
  },
  isActive: {
    type: Boolean,
    default: false
  },
  restOptionsAmount: {
    type: Number,
    default: 0
  },
  isInsideModal: {
    type: Boolean,
    default: false
  }
});

const optionItem = ref(null);

const optionName = computed(() => props.option.colorCode || props.option.title);
const isOos = computed(() => !props.option.inStock);

const itemImageUrl = computed(() => {
  const url = new URL(
    window.location.protocol + props.option.consolidatedImageUrl
  );
  url.searchParams.set('height', '200');
  url.searchParams.set('width', '200');

  return url.toString();
});
</script>
